export default __webpack_public_path__ + "static/media/MagicStories.cac1b83d.png";